module.exports = __webpack_public_path__ + "img/logo.e0ea21e3.svg";